import HttpFactory from '../factory';

export interface UserPaintAddPayload {
  imageUrl: string;
  originalImageUrl?: string;
  authorTgNickname: string;
  club: string;
  isPhoto?: boolean;
}

export type UserPaintAddResult = unknown;

export interface UserPaintApproved {
  imageUrl: string;
}

class UserPaintsModule extends HttpFactory {
  private readonly RESOURCE = 'user-paints/add';
  private readonly APPROVED_RESOURCE = 'user-paints/approved';

  async addPaint(payload: UserPaintAddPayload): Promise<UserPaintAddResult> {
    return await this.call<UserPaintAddResult>('POST', this.RESOURCE, payload, {
      retry: 0,
    });
  }

  async getApprovedPaints(): Promise<UserPaintApproved[]> {
    return await this.call<UserPaintApproved[]>('GET', this.APPROVED_RESOURCE, undefined, {
      retry: 0,
    });
  }
}

export default UserPaintsModule;
